import { Controller } from "@hotwired/stimulus";

export default class extends Controller<HTMLElement> {
  static values = { remove: String };

  declare readonly removeValue: string;

  private boundStrip = () => this.strip();

  connect() {
    this.element.addEventListener("lexxy:initialize", this.boundStrip);
    this.strip();
  }

  disconnect() {
    this.element.removeEventListener("lexxy:initialize", this.boundStrip);
  }

  private strip() {
    for (const name of this.removeValue.split(/\s+/).filter(Boolean)) {
      this.element
        .querySelectorAll(`button[name="${name}"]`)
        .forEach((button) => button.remove());
    }
  }
}
